import styles from "./drive-row.module.css";
import { Stack, TableCell, TableRow } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import Moment from "react-moment";
import DriveRowActionCell from "./DriveRowActionCell";
import DriveService from "../../services/DriveService";
import useDrive from "../../hooks/useDrive";
import { DRIVE_TYPES } from "../../config/appConst";
import DownloadActionCell from "./DownloadActionCell";

export default function DriveRow({ row }) {
  const [show, setShow] = useState(false);
  const { CurrentDrive, changeCurrentDrive, changeSelectedRow, changePreviewObject } = useDrive();

  const loadMe = async () => {
    const { parent, driveType } = CurrentDrive;
    const path = parent ? parent + "/" + row.Key : row.Key;
    if (row.type === "folder") {
      const res = await DriveService.getFileTree(path, driveType);
      let current = { parent: path, driveType: driveType };
      if (driveType === DRIVE_TYPES.SHARED) {
        current.sharedDrive = res;
      } else {
        current.drive = res;
      }
      changeCurrentDrive(current);
    }
  };

  const showMe = () => {
    changeSelectedRow(row);
    changePreviewObject(row)
  };
  const clickHandler = () => {
    if (row.type === 'folder') {
      loadMe(row)
    } else {
      showMe(row)
    }
  }
  return (
    <TableRow
      className={styles.driveRow}
      key={row.id}
      onMouseOver={() => setShow(true)}
      onMouseOut={() => setShow(false)}
    >
      <TableCell
        onClick={clickHandler}
        sx={{ cursor: "pointer" }}
      >
        <Stack direction={"row"}>
          <div className={styles.iconContainer}>{row.icon}</div>
          <div className={styles.itemName}>{row.Key}</div>
        </Stack>
      </TableCell>
      <TableCell align="right"
                 onClick={clickHandler}
                 sx={{ cursor: "pointer" }}
      >{row.Size}</TableCell>
      <TableCell align="right"
                 onClick={clickHandler}
                 sx={{ cursor: "pointer" }}
      >
        {row.LastModified ? (
          <Moment format="YYYY-MM-DD HH:mm:ss">{row.LastModified}</Moment>
        ) : (
          ""
        )}
      </TableCell>
      <DownloadActionCell show={show} row={row} cell={true} />
      <DriveRowActionCell show={show} row={row} cell={true} />
    </TableRow>
  );
}
